export const DEMO_SITES = [
    {
        id: "physio",
        name: "Physio on Elm",
        industry: "Physiotherapy",
        domain: "physio-on-elm.demo",
        eyebrow: "Independent clinic — 412 Elm Street, next to King",
        lines: [
            "Hands-on physiotherapy",
            "for people who want to get",
            "back to work, sport, and",
            "ordinary days.",
        ],
        accentLine: "ordinary days.",
        pills: ["No referral required", "Seen within 7 days", "Free parking"],
        nav: ["Manifesto", "Services", "Hours", "Insurance", "Book"],
        status: "Open now · until 6:30 PM",
        photos: [
            {
                src: "https://images.unsplash.com/photo-1640746530069-1d413652cfd1?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
                alt: "Manual physiotherapy treatment",
                caption: "Fig. 01 — Manual therapy, one clinician one patient",
                grayscale: 35,
            },
            {
                src: "https://images.pexels.com/photos/8219160/pexels-photo-8219160.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
                alt: "Kinesiology taping during rehabilitation",
                caption: "Fig. 02 — Sport taping & rehab",
                grayscale: 20,
            },
        ],
        theme: {
            bg: "#F8F6F0",
            ink: "#121315",
            accent: "#C85A32",
            muted: "#525866",
            line: "#E2E0D8",
            sand: "#EEEDE7",
            badge: "#EAE8DF",
        },
    },
    {
        id: "bakery",
        name: "Mill & Rye",
        industry: "Bakery",
        domain: "millandrye.demo",
        eyebrow: "Neighbourhood bakery — 88 King Street West",
        lines: [
            "Bread from the mill,",
            "pastries before dawn,",
            "and a shop that smells",
            "like Saturday morning.",
        ],
        accentLine: "like Saturday morning.",
        pills: ["Baked daily at 5am", "Sourdough & viennoiserie", "Coffee to stay"],
        nav: ["Menu", "Story", "Hours", "Order"],
        status: "Open now · until 3:00 PM",
        photos: [
            {
                src: "https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=1200&q=80",
                alt: "Fresh loaves on a bakery rack",
                caption: "Fig. 01 — Country loaves, pulled at dawn",
                grayscale: 10,
            },
            {
                src: "https://images.unsplash.com/photo-1517433670267-08bbd4be890f?auto=format&fit=crop&w=900&q=80",
                alt: "Baker shaping dough",
                caption: "Fig. 02 — Hands, flour, rye",
                grayscale: 0,
            },
        ],
        theme: {
            bg: "#F4EFE6",
            ink: "#1A1410",
            accent: "#B85C38",
            muted: "#6B5A4E",
            line: "#E4D8C8",
            sand: "#EDE4D6",
            badge: "#E8DCCB",
        },
    },
    {
        id: "law",
        name: "North Bench",
        industry: "Law",
        domain: "northbench.demo",
        eyebrow: "Independent counsel — St. Catharines & Niagara",
        lines: [
            "Clear advice for",
            "families, founders,",
            "and the work that",
            "cannot wait.",
        ],
        accentLine: "cannot wait.",
        pills: ["Family & estates", "Small business", "By appointment"],
        nav: ["Practice", "Approach", "People", "Contact"],
        status: "Open · Mon–Fri 9:00–5:00",
        photos: [
            {
                src: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1200&q=80",
                alt: "Handshake across a meeting table",
                caption: "Fig. 01 — Counsel, not a maze of retainers",
                grayscale: 40,
            },
            {
                src: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=900&q=80",
                alt: "Legal documents on a desk",
                caption: "Fig. 02 — Paper that actually gets read",
                grayscale: 25,
            },
        ],
        theme: {
            bg: "#F3F1EB",
            ink: "#161C24",
            accent: "#9A7B4F",
            muted: "#5A6270",
            line: "#DDD8CE",
            sand: "#E8E4DB",
            badge: "#E3DFD6",
        },
    },
    {
        id: "gym",
        name: "Ironwood",
        industry: "Strength gym",
        domain: "ironwood.demo",
        eyebrow: "Independent gym — small floor, heavy work",
        lines: [
            "Strength training",
            "for people who are",
            "done with crowded",
            "big-box noise.",
        ],
        accentLine: "big-box noise.",
        pills: ["Coached sessions", "Open gym hours", "No contracts"],
        nav: ["Training", "Floor", "Hours", "Join"],
        status: "Open now · until 8:00 PM",
        photos: [
            {
                src: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=1200&q=80",
                alt: "Barbell on a gym floor",
                caption: "Fig. 01 — Iron, wood, enough space to work",
                grayscale: 30,
            },
            {
                src: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=900&q=80",
                alt: "Athlete training with a kettlebell",
                caption: "Fig. 02 — Coached, not left alone",
                grayscale: 20,
            },
        ],
        theme: {
            bg: "#ECEAE4",
            ink: "#141414",
            accent: "#3F6B45",
            muted: "#5C6158",
            line: "#D8D6CE",
            sand: "#E4E1D8",
            badge: "#DDDBD3",
        },
    },
    {
        id: "salon",
        name: "Harbour Row",
        industry: "Hair salon",
        domain: "harbourrow.demo",
        eyebrow: "Independent salon — colour, cut, quiet chairs",
        lines: [
            "Colour and cut",
            "for people who want",
            "the chair to feel",
            "like an hour off.",
        ],
        accentLine: "like an hour off.",
        pills: ["Colour specialists", "By appointment", "Street parking"],
        nav: ["Services", "Stylists", "Lookbook", "Book"],
        status: "Open now · until 7:00 PM",
        photos: [
            {
                src: "https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=1200&q=80",
                alt: "Salon interior with styling chairs",
                caption: "Fig. 01 — The row, late afternoon light",
                grayscale: 15,
            },
            {
                src: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?auto=format&fit=crop&w=900&q=80",
                alt: "Hair colour being mixed",
                caption: "Fig. 02 — Colour mixed to the person, not the chart",
                grayscale: 0,
            },
        ],
        theme: {
            bg: "#F7F1ED",
            ink: "#261F1C",
            accent: "#C45B4A",
            muted: "#6E625C",
            line: "#E5D9D2",
            sand: "#EFE6E0",
            badge: "#E9DFD8",
        },
    },
    {
        id: "landscape",
        name: "Cedar & Stone",
        industry: "Landscaping",
        domain: "cedarandstone.demo",
        eyebrow: "Independent crew — Niagara gardens & hardscape",
        lines: [
            "Gardens, stone,",
            "and yards that stay",
            "looked-after.",
        ],
        accentLine: "looked-after.",
        pills: ["Design & build", "Seasonal care", "Free site visit"],
        nav: ["Work", "Process", "Season", "Enquire"],
        status: "Booking spring installs",
        photos: [
            {
                src: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1200&q=80",
                alt: "Garden path with planting",
                caption: "Fig. 01 — Beds that hold through July",
                grayscale: 10,
            },
            {
                src: "https://images.unsplash.com/photo-1558904541-efa843a96f01?auto=format&fit=crop&w=900&q=80",
                alt: "Stone patio in a backyard",
                caption: "Fig. 02 — Stone laid once, properly",
                grayscale: 5,
            },
        ],
        theme: {
            bg: "#F1F0E8",
            ink: "#1C2418",
            accent: "#6A7F3A",
            muted: "#5B6454",
            line: "#D9D7CC",
            sand: "#E6E4DA",
            badge: "#DEDDD3",
        },
    },
];
